import Vue from 'vue'
//@ts-ignore
import Vuetify from 'vuetify/lib'
import fr from 'vuetify/src/locale/fr'
//@ts-ignore
//import { preset } from 'vue-cli-plugin-vuetify-preset-crane/preset'

Vue.use(Vuetify);

export default new Vuetify({
  //preset,
  theme: {
    themes: {
      light: {
        primary: '#5a7b7d',
        secondary: '#779a9c'/*,
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'        */
      },
    },
  },
    lang: {
      locales: { fr },
      current: 'fr',
    },
});
